// services/titres.js
import { get } from './api';

export const fetchTitresParCategorie = async (categorie) => {
  const res = await get(`/titres?categorie=${encodeURIComponent(categorie)}`);
  return res.data;
};
